import { faSave, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useFormikContext } from 'formik'
import { Dropdown, DropdownOption, Input } from 'src/components/Forms'
import Checkbox from 'src/components/Forms/Checkbox'
import { Body, Footer } from 'src/components/theme/Models/Modal'
import Distributions from './Distributions'

interface FormProps {
  toggle: () => void
  lookups?: {
    positions: DropdownOption[]
  }
  isLoading?: boolean
  hasError?: boolean
  disableSave?: boolean
}

const Form: React.FC<FormProps> = (props) => {
  const { lookups, hasError, toggle, isLoading, disableSave } = props
  const { handleSubmit } = useFormikContext()

  return (
    <>
      <Body error={{
        error: 'There was an issue updating the candidate details.',
        show: hasError ?? false
      }}
      >
        <Input type='text' name='name.first' label='First Name' />
        <Input type='text' name='name.last' label='Last Name' />
        <Dropdown name='position' label='Position' options={lookups?.positions ?? []} />
        <Distributions />
        <Checkbox id='details' name='details' label='Copy Details' />
        <Checkbox id='contact' name='contact' label='Copy Contact Information' />
        <Checkbox id='rates' name='rates' label='Copy Rates' />
        <Checkbox id='notes' name='notes' label='Copy Notes' />
        <Checkbox id='attachments' name='attachments' label='Copy Attachments' />
      </Body>
      <Footer
        toggle={toggle}
        onAction={handleSubmit}
        action={{
          text: 'Save',
          icon: isLoading === true ? faSpinner : faSave,
          color: 'primary',
          disabled: disableSave === true || isLoading
        }}
      />
    </>
  )
}

export default Form
